// @flow

import React, { Component } from 'react';

type FileInputProps = {
  accept: '*/*' | 'image/*' | 'application/json' | 'text/plain',
  id?: string,
  isHidden: boolean,
  maxKb: number,
  name: string,
  value: string,
  onChangeValue: (file: File, name: string) => void,
  onInvalid: (reason: string) => void,
};

export default class FileInput extends Component<FileInputProps> {
  static defaultProps = {
    accept: '*/*',
    isHidden: false,
    maxKb: 5 * 1024, // 5MB
    value: '', // Default to empty string so same file can be reselected
  };

  onChange = (e: SyntheticInputEvent<HTMLInputElement>) => {
    const { props } = this;
    const file = e.target.files[0];
    const kb = Math.ceil(file.size / 1024);
    if (kb > props.maxKb) {
      props.onInvalid(
        `Whoops, your file is too large at ${kb}KB. Please choose a file smaller than ${props.maxKb}KB.`
      );
    } else {
      props.onChangeValue(file, props.name);
    }
  };

  render() {
    const { props } = this;
    const style = props.isHidden ? { display: 'none' } : undefined;
    return (
      <input
        accept={props.accept}
        id={props.id}
        name={props.name}
        onChange={this.onChange}
        style={style}
        type="file"
        value={props.value}
      />
    );
  }
}
